import React, { useState } from 'react';
import { BfButtonBlue, DeactivateButton } from '../../../Styling/styledForm/styledBlueForm'
import {
  StyledModal,
  StyledModalBody,
  StyledModalFooter,

} from "../../../Styling/styledModal/styledModals";

const DeactivateModal = (props) => {
  const { dialogVisible, cancelHandler, acceptHandler, userEmail, kreditor } = props.deactivateModal;

  const deactivateKreditor = props.deactivateKreditor;

  const messages = props.deactivateModal.messages;

  const handleOkClick = () => {
    acceptHandler(deactivateKreditor);
  };

  const handleCancelClick = () => {
    cancelHandler();
  };

  return (
    <StyledModal show={props.deactivateModal.dialogVisible} centered size="lg" >
      <StyledModalBody style={{ width: '100%' }}>
        {<h4>{messages.deactivateTitle}</h4>}
        {<p>{messages.deactivateForUser}</p>}
        {deactivateKreditor ? 
            (<p>Merk at dette vil deaktivere kredittvurdering for kreditor <b>{props.deactivateModal.kreditor}</b> og bruker <b>{props.deactivateModal.userEmail}</b>. Kredittvurdering vil deaktiveres på denne kreditoren for alle brukere som har tilgang på denne kreditoren.</p>) 
            : <p>Merk at dette vil kun deaktivere kredittvurdering for bruker <b>{userEmail}</b>, og ikke for andre brukere som har signert avtalen og tilgang på den sammen kreditoren.</p>}
      </StyledModalBody>

      <StyledModalFooter style={{ width: '100%', padding: '10px 10px 0px' }}>
        <div style={{ display: 'flex', width: '100%', paddingBottom: '30px' }}>
          <DeactivateButton onClick={handleOkClick}>
            {messages.deactivateButton}
          </DeactivateButton>
          &nbsp;
          &nbsp;
          <BfButtonBlue variant="primary" onClick={handleCancelClick}>
            {messages.cancel}
          </BfButtonBlue>
        </div>
      </StyledModalFooter>
    </StyledModal>
  );
};

export default DeactivateModal;

